/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidacyAnswerDataSchema = z.object({
	question: z.string(),
	values: z.array(z.string()),
})

export type CandidacyAnswerDataSchema = z.infer<typeof candidacyAnswerDataSchema>
